<template>
  <div class="tabela-icms">
    <el-row>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <el-table :data="list" border :row-class-name="tableRowClassName" empty-text="Sem dados!">
          <el-table-column prop="origem" label="Origem" width="80"></el-table-column>
          <el-table-column label="DESTINO" align='center'>
            <el-table-column prop="destino_AC" label="AC" width="45"></el-table-column>
            <el-table-column prop="destino_AL" label="AL" width="45"></el-table-column>
            <el-table-column prop="destino_AM" label="AM" width="45"></el-table-column>
            <el-table-column prop="destino_AP" label="AP" width="45"></el-table-column>
            <el-table-column prop="destino_BA" label="BA" width="45"></el-table-column>
            <el-table-column prop="destino_CE" label="CE" width="45"></el-table-column>
            <el-table-column prop="destino_DF" label="DF" width="45"></el-table-column>
            <el-table-column prop="destino_ES" label="ES" width="45"></el-table-column>
            <el-table-column prop="destino_GO" label="GO" width="45"></el-table-column>
            <el-table-column prop="destino_MA" label="MA" width="45"></el-table-column>
            <el-table-column prop="destino_MT" label="MT" width="45"></el-table-column>
            <el-table-column prop="destino_MS" label="MS" width="45"></el-table-column>
            <el-table-column prop="destino_MG" label="MG" width="45"></el-table-column>
            <el-table-column prop="destino_PA" label="PA" width="45"></el-table-column>
            <el-table-column prop="destino_PB" label="PB" width="45"></el-table-column>
            <el-table-column prop="destino_PR" label="PR" width="45"></el-table-column>
            <el-table-column prop="destino_PE" label="PE" width="45"></el-table-column>
            <el-table-column prop="destino_PI" label="PI" width="45"></el-table-column>
            <el-table-column prop="destino_RN" label="RN" width="45"></el-table-column>
            <el-table-column prop="destino_RS" label="RS" width="45"></el-table-column>
            <el-table-column prop="destino_RJ" label="RJ" width="45"></el-table-column>
            <el-table-column prop="destino_RO" label="RO" width="45"></el-table-column>
            <el-table-column prop="destino_RR" label="RR" width="45"></el-table-column>
            <el-table-column prop="destino_SC" label="SC" width="45"></el-table-column>
            <el-table-column prop="destino_SP" label="SP" width="45"></el-table-column>
            <el-table-column prop="destino_SE" label="SE" width="45"></el-table-column>
            <el-table-column prop="destino_TO" label="TO" width="45"></el-table-column>
          </el-table-column>
        </el-table>
        <p class="primeira">Para aplicação da tabela nas operações interestaduais deverá tomar o seguinte ponto de partida: </p>
        <p class="meio">na coluna vertical estão destacados os Estados de origem das operações; </p>
        <p class="meio">na coluna horizontal destacam-se os Estados de destino das operações de comercialização, dos produtos, das mercadorias, dos serviços prestados; </p>
        <p class="meio">os quadros em branco referem-se às operações internas. </p>
        <p>A presente tabela tem por base a Resolução do Senado Federal n. 22/89. </p>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import axios from "axios";

// const url = "http://" + window.location.hostname + ":8000/api";
const url = '/api';

export default {
  data() {
    return {
      list: [],
    };
  },

  mounted() {
    axios
      .get(url + "/config_icms/", {
        headers: {
          Authorization: "Bearer " + this.$store.state.token,
        },
      })
      .then((response) => {
        if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          this.list = response.data;
        }
      })
      .catch((err) => {
        this.total = "erro" + err;
      });
  },
  methods: {
    tableRowClassName({ rowIndex }) {
      if (rowIndex === 19) {
        return "success-row";
      }
      return "";
    },
  },
};
</script>
<style >
  .tabela-icms tr:nth-child(even) {
    background: #fff;
  }
  .tabela-icms tr:nth-child(odd) {
    background: #eee;
  }
  .tabela-icms .el-table .success-row {
    background: #f56c6c;
    color: #000;
    font-weight: bold;    
  }
/* 
  .tabela-icms .el-table tr:hover {
    background: yellow !important;
    color: #000;
    font-weight: bold;
  }
*/
/* 
  .tabela-icms .el-table .success-row:hover {
    background: yellow;
    color: #000;
    font-weight: bold;
  }
*/
  .tabela-icms p {
    text-align: left;
    font-size: 12px;
    margin-bottom: 0px;
    margin-top: 0px;
    padding-left: 30px;  
  }
  .tabela-icms .primeira{
    margin-top: 10px;;
  }
  .tabela-icms .meio{
    padding-left: 40px;
  }
  .tabela-icms p:last-child {
    margin-top: 15px;
  }
</style>
